<template>
  <b-container class="register-vehicle-view-div">
    <h3>Scan QR or enter code manually</h3>
    <b-row>
      <b-col cols-md="4" offset-md="1">
        <qrcode-stream @decode="pairVehicle"></qrcode-stream>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols-md="4" offset-md="1">
        <b-input-group prepend="code" class="mt-3">
          <b-form-input :disabled="processingInput" v-model="codeInputFieldVal" placeholder="Insert scooter code & click Pair"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="processingInput" @click="pairVehicle(codeInputFieldVal)" variant="outline-success">Pair</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

  import { QrcodeStream } from 'vue-qrcode-reader';
  import { firebaseAuth } from '@/firebase';
  import axios from 'axios';
  import store from "@/store";

  export default {
    name: "RegisterVehicleView",
    components: {
      QrcodeStream
    },
    data() {
      return {
        codeInputFieldVal: '',
        processingInput: false
      }
    },
    beforeCreate() {
      let unsubscribe = store.watch(() => store.getters['user'], user => {
        unsubscribe();
        if (user && user.vehicle)
          this.$router.push({ name: 'Map' })
      });
    },
    methods: {
      async pairVehicle(code) {
        this.processingInput = true;

        let authToken = await firebaseAuth.currentUser.getIdToken();
        try {
          let response = await axios.post(
              `https://europe-west3-coscooter-eu-staging.cloudfunctions.net/pair?apiKey=${authToken}`,
              { vehicleCode: code }
          );

          if (response.status !== 200 && response.status !== 204)
            this.processingInput = false;
          else {
            await new Promise(resolve => setTimeout(resolve, 1200));
            await this.$router.push( { name: 'Map' });
          }
        } catch (e) {
          this.processingInput = false;
        }
      }
    }
  }
</script>

<style>
  .register-vehicle-view-div {
    padding-top: 100px
  }
</style>
